import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(ya tatu|ya kwanza|ya pil|ya tatu)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(kabla|baada)/i,
  abbreviated: /^(kabla ya kristo|baada ya kristo)/i,
  wide: /^(kabla ya kristo|baada ya kristo)/i,
};
const parseEraPatterns = {
  any: [/(^kabla|^kabla ya kristo)/i, /(^baada|^baada ya kristo)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^Robo ya [1234]/i,
  wide: /^Robo (ya kwanza|nusu|ya tatu|ya nne)/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/Robo ya 1/i, /Robo ya 2/i, /Robo ya 3/i, /Robo ya 4/i],
  wide: [/^Robo ya kwanza/i, /Robo nusu/i, /Robo ya tatu/i, /Robo ya nne/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ago|sep|okt|nov|des)/i,
  wide: /^(januari|februari|machi|aprili|mei|juni|julai|agosti|septemba|oktoba|novemba|desemba)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  any: /^(jumapili|jumatatu|jumanne|jumatano|alhamisi|ijumaa|jumamosi)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [
    /^jumap/i,
    /^jumatat/i,
    /^juman/i,
    /^jumatan/i,
    /^a/i,
    /^i/i,
    /^jumam/i,
  ],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|asubuhi|mchana|jioni|usiku)/i,
  any: /^(asubuhi|mchana|usiku wa manane|mchana|asubuhi|mchana|jioni|usiku)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^n/i,
    morning: /asubuhi/i,
    afternoon: /mchana/i,
    evening: /jioni/i,
    night: /usiku/i,
  },
  any: {
    am: /asubuhi/i,
    pm: /mchana/i,
    midnight: /usiku wa manane/i,
    noon: /mchana/i,
    morning: /asubuhi/i,
    afternoon: /mchana/i,
    evening: /jioni/i,
    night: /usiku/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

export default match;
